import DialogBody from '$tablet-app/src/app/components/Dialog/DialogBody';
import getAllergyPreferenceLabel from '$tablet-app/src/app/recipes/preferences/functions/getAllergyPreferenceLabel';
import getMealAvoidancesLabel from '$tablet-app/src/app/recipes/preferences/functions/getAvoidancePreferenceLabel';
import getBudgetPreferenceLabel from '$tablet-app/src/app/recipes/preferences/functions/getBugetPreferenceLabel';
import getComplexityPreferenceLabel from '$tablet-app/src/app/recipes/preferences/functions/getComplexityPreferenceLabel';
import getDietBalanceLabel from '$tablet-app/src/app/recipes/preferences/functions/getDietBalanceLabel';
import { palette } from '$tablet-app/src/app/theme';
import React from 'react';
import styled from 'styled-components/native';
import MealPlanPreferenceTile from '../../MealPlanPreferenceTile';
import {
  useMealPreferenceDialogState,
  useOpenPreferenceView,
} from '../../store/useMealPreferenceDialogState';

const MainPreferencesView = () => {
  const changeView = useOpenPreferenceView();

  const preferences = useMealPreferenceDialogState(
    (state) => state.preferences
  );

  return (
    <Body>
      <PreferenceRow>
        <MealPlanPreferenceTile
          icon="cutlery"
          iconColor={palette.success_500}
          color={palette.success_200}
          title="Which meals"
          value={preferences.meals_to_plan?.join(', ') || '--'}
          goTo="meals_to_plan"
          onPress={changeView}
        />

        <MealPlanPreferenceTile
          icon="carrot"
          iconColor={palette.orange_700}
          color={palette.orange_200}
          title="Dietary preferences"
          value={getDietBalanceLabel(preferences.eats_meat)}
          goTo="eats_meat"
          onPress={changeView}
        />

        <MealPlanPreferenceTile
          icon="clock"
          iconColor={palette.yellow_700}
          color={palette.yellow_200}
          title="Time and effort"
          value={getComplexityPreferenceLabel(preferences.time_and_effort)}
          goTo="time_and_effort"
          onPress={changeView}
        />

        <MealPlanPreferenceTile
          icon="usd-circle"
          iconColor={palette.success_500}
          color={palette.success_200}
          title="Budget"
          value={getBudgetPreferenceLabel(preferences.budget)}
          goTo="budget"
          onPress={changeView}
        />
      </PreferenceRow>
      <PreferenceRow>
        <MealPlanPreferenceTile
          icon="user-friends"
          iconColor={palette.secondary_700}
          color={palette.secondary_200}
          title="People"
          value={preferences.people}
          goTo="people"
          onPress={changeView}
        />

        <MealPlanPreferenceTile
          icon="ban"
          iconColor={palette.primary_70}
          color={palette.primary_200}
          title="Avoids"
          value={getMealAvoidancesLabel(preferences.avoidances)}
          goTo="avoidances"
          onPress={changeView}
        />

        <MealPlanPreferenceTile
          icon="allergies"
          iconColor={palette.orange_700}
          color={palette.orange_200}
          title="Allergies"
          value={getAllergyPreferenceLabel(preferences.allergies)}
          goTo="allergies"
          onPress={changeView}
        />

        <MealPlanPreferenceTile
          icon="alarm-clock"
          iconColor={palette.secondary_700}
          color={palette.secondary_200}
          title="Reminders"
          value={preferences.reminders?.join(', ') || '--'}
          goTo="reminders"
          onPress={changeView}
        />
      </PreferenceRow>
    </Body>
  );
};

const Body = styled.View`
  width: 1000px;
`

const PreferenceRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 20px;
  gap: 20px;
`;

export default MainPreferencesView;
